module.exports = __webpack_public_path__ + "static/media/foto_brak_limitu.16c15ebb.jpg";